import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import moment from "moment/moment";
import Spinner from "../../Components/spinner/spinner";
import Paginations from "../../Components/Pagination/pagination";
import ValidationMessage from "../ValidationMessage/validationMessage";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Modal } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Calendars from "react-calendar";
import ScrollBars from "react-scrollbar";
import NoRecord from "../../Components/noRecord";
import UseAppointmentList from "./Hooks/useAppointmentList";
import { intialRole } from "../../Utils/Utils";
import { Backdrop, IconButton } from "@mui/material";
import ServiceImg from "../../Assets/images/services-icon.png";
import { BookingInfo } from "../../Constants/generalConfig";
import DownloadIcon from "@mui/icons-material/Download";

import MailIcon from "@mui/icons-material/Mail";

const AppointmentList = () => {
  const {
    appointmentDelete,
    setSelectedStaffId,
    selectedStaffId,
    updateStaff,
    handleChange,
    appointmentReschedule,
    timesSlot,
    clearAllFilter,
    setStatus,
    setClient,
    setTeam,
    handleInputChange,
    getAppointmentData,
    setModalData,
    setPage,
    setShow,
    setShowModal,
    setShowFilter,
    setSlotTime,
    setSlots,
    navigate,
    setDateFilter,
    getStaffList,
    setShowDelete,
    setShowUpdateStaff,
    showUpdateStaff,
    setTab,
    clientCombo,
    setCount,
    downloadBillAPI,
    setShowEmailModal,
    handleEmailChange,
    setButtonType,
    downloadComboBillAPI,
    setSelectedAppointmentId,
    setApiType,
    handleEmailSubmit,
    setFormData,
    setShowBillGenModal,
    handleBillGenerateChange,
    setCategoryId,
    handleServiceChange,
    bookAppointment,
    bookAppointmentFormik,
    getBranchList,
    setEmailError,
    emailError,
    teamMember,
    branchData,
    clientData,
    serviceList,
    serviceCategoryList,
    billFormValues,
    showBillGenModal,
    tab,
    comboImgPath,
    clientComboData,
    showDelete,
    cancelAppointment,
    appointmentListData,
    modalData,
    teamList,
    clientList,
    spinner,
    count,
    page,
    PER_PAGE,
    show,
    showModal,
    showFilter,
    slotTime,
    slots,
    statusNames,
    val,
    dateFilter,
    teamMemberList,
    filterInput,
    userInfo,
    showEmailModal,
    buttonType,
    formData,
  } = UseAppointmentList();
  const Reschedule_Permission = intialRole({
    permission: "appointment",
    userData: userInfo,
    section: "reschedule",
  });
  const Delete_Permission = intialRole({
    permission: "appointment",
    userData: userInfo,
    section: "delete",
  });
  const Cancel_Permission = intialRole({
    permission: "appointment",
    userData: userInfo,
    section: "cancel",
  });

  const dummyData = [
    { name: "one", id: "1" },
    { name: "two", id: "2" },
    { name: "three", id: "3" },
    { name: "four", id: "4" },
  ];

  const visitType = [
    { name: "INOFFICE", id: "INOFFICE" },
    { name: "HOME", id: "HOME" },
    { name: "ONLINE", id: "ONLINE" },
  ];

  return (
    <>
      <ToastContainer />
      <section>
        <div className="m-t-3 cus-padd cusheight position-relative">
          {spinner ? <Spinner /> : null}
          <header style={{ paddingTop: "-10px" }}>
            <div className="d-flex justify-content-between">
              <h2 className="page-tittle">Appointments List</h2>
              <div>
                <OverlayTrigger
                  overlay={<Tooltip id="tooltip-disabled">Calendar</Tooltip>}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="40"
                    width="40"
                    className="icons-size cursor "
                    onClick={() => navigate("calendar")}
                    style={{ marginTop: "-10px" }}
                  >
                    <path d="m18.208 29.875-5.291-5.25 1.5-1.458 3.791 3.791 7.375-7.416 1.5 1.458Zm-9.291 5.958q-1.292 0-2.209-.916-.916-.917-.916-2.25V10.292q0-1.292.916-2.23.917-.937 2.209-.937h2.416V3.792h2.292v3.333H26.5V3.792h2.208v3.333h2.375q1.292 0 2.209.937.916.938.916 2.23v22.375q0 1.333-.916 2.25-.917.916-2.209.916Zm0-2.125h22.166q.375 0 .688-.333.312-.333.312-.708V17H7.917v15.667q0 .375.312.708.313.333.688.333Zm-1-18.833h24.166v-4.583q0-.375-.312-.709-.313-.333-.688-.333H8.917q-.375 0-.688.333-.312.334-.312.709Zm0 0V9.25v5.625Z" />
                  </svg>
                </OverlayTrigger>
              </div>
            </div>
            <hr />
            <nav className="mb-3">
              <div className="nav nav-tabs tabber" id="nav-tab" role="tablist">
                <button
                  className={` ${tab === 1 ? "activeNav" : "unActiveNav"} border-0`}
                  onClick={() => {
                    setTab(1);
                    setPage(1);
                    setCount(1);
                  }}
                  id="basicdetails"
                  type="button"
                >
                  Appointments List
                </button>
                {/* <button className={` ${tab === 2 ? 'activeNav' : 'unActiveNav'} border-0`} type="button" onClick={() => { setTab(2) }} > */}
                <button
                  className={` ${tab === 2 ? "activeNav" : "unActiveNav"} border-0`}
                  type="button"
                  onClick={() => {
                    setTab(2);
                    clientCombo();
                    setPage(1);
                    setCount(1);
                  }}
                >
                  Combo & Packages
                </button>
              </div>
            </nav>
          </header>
          {tab === 1 && (
            <div className="scroll">
              <div className="row">
                {intialRole({
                  permission: "appointment",
                  userData: userInfo,
                  section: "viewAppointmentList",
                }) ? (
                  <div className="col-sm-12 listpadding">
                    {appointmentListData.length === 0 ? null : (
                      <p className="d-flex float-start mb-0">
                        Total Appointments :{" "}
                        {appointmentListData.length === 0
                          ? 0
                          : appointmentListData.totalCount}
                      </p>
                    )}

                    <div className="d-flex justify-content-end align-items-center">
                      {/* <button onClick={() => setShowBillGenModal(true)}
                          className="btn yesbtn">
                          Bill Generate
                        </button> */}
                      <OverlayTrigger
                        overlay={
                          <Tooltip id="tooltip-disabled">Filter</Tooltip>
                        }
                      >
                        <ul className="navicon mb-0">
                          <li>
                            <i
                              className="fa-solid fa-sliders"
                              onClick={() => {
                                setShowFilter(true);
                              }}
                              style={{ cursor: "pointer" }}
                            ></i>
                          </li>
                        </ul>
                      </OverlayTrigger>
                    </div>
                    {/* Apppointment List Start */}
                    {appointmentListData.length === 0 ? (
                      <NoRecord />
                    ) : (
                      <div className="table-responsive">
                        <table className="table cus-table">
                          <thead className="text-center tableheader">
                            <tr>
                              <th scope="col"></th>
                              <th scope="col">Date</th>
                              <th scope="col">Time</th>
                              <th scope="col">Appointment ID</th>
                              <th scope="col">Branch</th>
                              <th scope="col">Client</th>
                              <th scope="col">Status</th>
                              {!Reschedule_Permission &&
                              !Delete_Permission &&
                              !Cancel_Permission ? null : (
                                <th scope="col">Action</th>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {appointmentListData.data?.map((item) => (
                              <tr key={item._id} className="cursor">
                                <td>
                                 {item.isNoPreference && (
  <OverlayTrigger
    overlay={<Tooltip id="tooltip-disabled">No preference appointment</Tooltip>}
  >
    <i className="fa fa-circle text-danger-glow blink me-1" />
  </OverlayTrigger>
)}

                                  
                                </td>
                                <td
                                  key={item._id}
                                  onClick={() =>
                                    navigate(`appointmentView/${item._id}`)
                                  }
                                >
                                  {moment(item.startDateTime).format(
                                    "DD-MM-YYYY",
                                  )}
                                </td>
                                <td
                                  onClick={() =>
                                    navigate(`appointmentView/${item._id}`)
                                  }
                                >
                                  {moment(item.startDateTime).format("LT")} -{" "}
                                  {moment(item.endDateTime).format("LT")}
                                </td>
                                <td
                                  onClick={() =>
                                    navigate(`appointmentView/${item._id}`)
                                  }
                                >
                                  {item.appointment_number}
                                </td>
                                <td
                                  onClick={() =>
                                    navigate(`appointmentView/${item._id}`)
                                  }
                                >
                                  {item.branchName}
                                </td>
                                <td
                                  onClick={() =>
                                    navigate(`appointmentView/${item._id}`)
                                  }
                                >
                                  {item.clientName}
                                </td>
                                <td
                                  onClick={() =>
                                    navigate(`appointmentView/${item._id}`)
                                  }
                                >
                                  {item.isRescheduled === true &&
                                  item.status === "CANCELLED"
                                    ? item.status
                                    : item.status === "PENDING"
                                      ? item.status
                                      : item.status === "DECLINED"
                                        ? item.status
                                        : item.isRescheduled === true
                                          ? "RESCHEDULE"
                                          : item.status}
                                </td>
                                {!Reschedule_Permission &&
                                !Delete_Permission &&
                                !Cancel_Permission ? null : (
                                  <td className="text-center">
                                    <ul
                                      className="iconul"
                                      style={{ marginBottom: "-1px" }}
                                    >
                                      {Delete_Permission &&
                                      item.status !== "VISITED" ? (
                                        <li>
                                          <OverlayTrigger
                                            overlay={
                                              <Tooltip id="tooltip-disabled">
                                                Delete
                                              </Tooltip>
                                            }
                                          >
                                            <i
                                              className="fa-solid fa-trash-can"
                                              onClick={() => {
                                                setModalData(item);
                                                setShowDelete(true);
                                              }}
                                            ></i>
                                          </OverlayTrigger>
                                        </li>
                                      ) : null}
                                      {Cancel_Permission &&
                                      item.status !== "VISITED" ? (
                                        <li>
                                          <OverlayTrigger
                                            overlay={
                                              <Tooltip id="tooltip-disabled">
                                                Cancel
                                              </Tooltip>
                                            }
                                          >
                                            <i
                                              className="fa-solid fa-ban disabled"
                                              onClick={() => {
                                                setModalData(item);
                                                if (
                                                  item.status !== "CANCELLED" &&
                                                  item.status !== "VISITED"
                                                ) {
                                                  setShowModal(true);
                                                }
                                              }}
                                            ></i>
                                          </OverlayTrigger>
                                        </li>
                                      ) : null}
                                      {Reschedule_Permission
                                        ? !item?.isComboPackage && (
                                            <li>
                                              <OverlayTrigger
                                                overlay={
                                                  <Tooltip id="tooltip-disabled">
                                                    Reschedule
                                                  </Tooltip>
                                                }
                                              >
                                                <i
                                                  className="fa-solid fa-calendar"
                                                  onClick={() => {
                                                    setModalData(item);
                                                    if (
                                                      !(
                                                        item.isRescheduled ===
                                                          true ||
                                                        item.status ===
                                                          "CANCELLED" ||
                                                        item.status ===
                                                          "VISITED" ||
                                                        item.status ===
                                                          "PENDING"
                                                      )
                                                    ) {
                                                      setShow(true);
                                                      getStaffList(item);
                                                    }
                                                  }}
                                                ></i>
                                              </OverlayTrigger>
                                            </li>
                                          )
                                        : null}
                                      {item.isNoPreference ? (
                                        <li>
                                          <OverlayTrigger
                                            overlay={
                                              <Tooltip id="tooltip-disabled">
                                                No Preference
                                              </Tooltip>
                                            }
                                          >

                                            
                                            <i   
                                              className="fa-solid fa-user-plus"
                                              onClick={() => {
                                                setModalData(item);
                                                setShowUpdateStaff(true);
                                                setSelectedStaffId("");
                                              }}
                                            ></i>
                                          </OverlayTrigger>
                                        </li>
                                      ) : null}
                                      {/* <li>
                                              {!item?.isComboPackage && item?.status === 'VISITED' ? <IconButton color='inherit' onClick={() =>{ setButtonType('download'); downloadBillAPI(item._id)}} sx={{ padding: "0px" }}><DownloadIcon /></IconButton> : ''}
                                            </li> */}
                                      {/* <li>
                                              {!item?.isComboPackage && item?.status === 'VISITED' ? <IconButton
                                                onClick={() => {
                                                  setButtonType('sendEmail');
                                                  setSelectedAppointmentId(item._id);
                                                  setApiType('appointment');
                                                  setShowEmailModal(true);
                                                }}
                                                className='p-0' color='inherit'
                                                title="Send Bill via Email"
                                              >
                                                <MailIcon />
                                              </IconButton> : ""}

                                            </li> */}
                                    </ul>
                                  </td>
                                )}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <div className="w-100 d-flex justify-content-center">
                          {count > 10 && (
                            <Paginations
                              setpage={setPage}
                              count={Math.ceil(count / PER_PAGE)}
                              page={page}
                            />
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="d-flex justify-content-center mt-5 me-5">
                    <h3>You don't have permission to access</h3>
                  </div>
                )}
              </div>
            </div>
          )}
          {tab === 2 && (
            <>
              {!clientComboData.length ? (
                <NoRecord />
              ) : (
                <div className="table-responsive">
                  <table className="table cus-table">
                    <thead className="text-center tableheader">
                      <tr>
                        <th scope="col">Image</th>
                        <th scope="col">Client Name</th>
                        <th scope="col">Name</th>
                        <th scope="col">Price</th>
                        <th scope="col">Validity(In Days)</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    {clientComboData?.length === 0 ? (
                      <div className="position-absolute top-20 start-50 mt-5">
                        <h3>No record found</h3>
                      </div>
                    ) : (
                      <tbody>
                        {clientComboData?.map((item) => (
                          <React.Fragment key={item._id}>
                            <tr
                              className="cursor"
                              onClick={() => {
                                navigate(`combo-view/${item._id}`);
                              }}
                            >
                              <td key={item._id}>
                                <img
                                  src={
                                    item.image === ""
                                      ? ServiceImg
                                      : comboImgPath + item.image
                                  }
                                  alt=""
                                  height={30}
                                  width={30}
                                  style={{ borderRadius: "50%" }}
                                />
                              </td>
                              <td>{item.clientName}</td>
                              <td>{item.name}</td>
                              <td>
                                {userInfo?.currencySymbol} {item.price}
                              </td>
                              <td>{item.validity}</td>
                              <td>
                                {item?.packageCompleted && (
                                  <IconButton
                                    color="inherit"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setButtonType("download");
                                      downloadComboBillAPI(item._id);
                                    }}
                                    sx={{
                                      padding: "0px",
                                      paddingRight: "15px",
                                    }}
                                  >
                                    <DownloadIcon />
                                  </IconButton>
                                )}
                                {/* {item?.packageCompleted && <IconButton
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setButtonType('sendEmail');
                                    setSelectedAppointmentId(item._id);
                                    setApiType('combo');
                                    setShowEmailModal(true);
                                  }}
                                  className='p-0' color='inherit'
                                  title="Send Bill via Email"
                                >
                                  <MailIcon />
                                </IconButton>} */}
                              </td>
                            </tr>
                          </React.Fragment>
                        ))}
                      </tbody>
                    )}
                  </table>
                  <div className="w-100 d-flex justify-content-center">
                    {clientComboData.length === 0
                      ? null
                      : count > 10 && (
                          <Paginations
                            setpage={setPage}
                            count={Math.ceil(count / PER_PAGE)}
                            page={page}
                          />
                        )}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
        <div className="">
          <p className="btn addbtn2">
            <OverlayTrigger
              overlay={<Tooltip id="tooltip-disabled">Calender</Tooltip>}
            >
              <i
                className="fa-solid fa-plus"
                onClick={() => navigate("calendar")}
              ></i>
            </OverlayTrigger>
          </p>
        </div>
      </section>

      {/* Email download bill modal */}
      <Modal
        centered
        show={showEmailModal}
        onHide={() => setShowEmailModal(false)}
      >
        <div className="modal-body">
          <h6 className="text-center"> Send email</h6>
          <div className="py-3 cus-form">
            <label htmlFor="">Email</label>
            <input
              type="text"
              name="email"
              onChange={(e) => {
                handleEmailChange(e);
                setEmailError(""); // Clear error while typing
              }}
              value={formData.email}
              className={`form-control ${emailError ? "is-invalid" : ""}`}
            />
            {emailError && <div className="invalid-feedback">{emailError}</div>}
          </div>
          <button
            style={{ marginLeft: "20%", marginRight: "20px" }}
            type="button"
            className="btn yesbtn"
            data-bs-dismiss="modal"
            //  onClick={() => { setFormData(''); setShowEmailModal(false) }}
            onClick={() => {
              setFormData({ email: "" });
              setShowEmailModal(false);
              setEmailError("");
              setButtonType("download"); // Reset button type
            }}
          >
            No
          </button>
          <button className="btn nobtn" onClick={handleEmailSubmit}>
            Submit
          </button>
        </div>
      </Modal>

      {/* Appointment Cancel Start  */}
      <Modal centered show={showModal} onHide={() => setShowModal(false)}>
        <div className="modal-body">
          <p className="text-center">Are You Sure !</p>
          <p className="text-center">You want to cancel this appointment</p>
          <div className="mb-3">
            <label className="form-label">Reason *</label>
            <textarea
              className="form-control"
              id="exampleFormControlTextarea1"
              rows="3"
              name="reason"
              value={cancelAppointment.values.reason}
              onChange={cancelAppointment.handleChange}
            ></textarea>
            <ValidationMessage formName={cancelAppointment} name={"reason"} />
          </div>
          <button
            type="submit"
            className="btn nobtn"
            onClick={cancelAppointment.handleSubmit}
            style={{ marginLeft: "20%" }}
          >
            Yes
          </button>
          <button
            type="button"
            className="btn yesbtn"
            data-bs-dismiss="modal"
            onClick={() => setShowModal(false)}
          >
            No
          </button>
        </div>
      </Modal>
      {/* Appointment Cancel End */}

      {/*Appointment Reschedule Start */}
      <Backdrop open={show}>
        <Offcanvas
          show={show}
          onHide={() => setShow(false)}
          placement="end"
          backdrop={false}
        >
          <div style={{ padding: "10px" }}>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              onClick={() => {
                setShow(false);
                setSlots([]);
              }}
            ></button>
            <h1
              className="popupheader text-center heading-color "
              id="offcanvasRightLabel"
            >
              Reschedule Appointment
            </h1>
          </div>
          <div className="offcanvas-body">
            <div className="cus-form">
              <div className="mb-3">
                <label className="form-label">Client Name *</label>
                <input
                  type="text"
                  className="form-control"
                  disabled
                  value={modalData.clientName}
                />
              </div>
              <div className="mb-3">
                <div className="d-flex justify-content-between align-items-center">
                  <label className="form-label">Booking Type *</label>
                  <BookingInfo />
                </div>
                <select
                  className="form-control"
                  name="visitType"
                  value={modalData.visitType}
                  disabled
                >
                  <option hidden>Select Booking Type</option>
                  <option value="INOFFICE">In-Office</option>
                  <option value="HOME">Home</option>
                  <option value="ONLINE">Online</option>
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label">Services Category*</label>
                <input
                  type="text"
                  className="form-control"
                  disabled
                  value={modalData.serviceCategoryName}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Service *</label>
                <input
                  type="text"
                  className="form-control"
                  disabled
                  value={modalData.serviceName}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Price</label>
                <input
                  type="number"
                  className="form-control"
                  disabled
                  value={modalData.amount || modalData.servicePrice}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Branch *</label>
                <input
                  type="text"
                  className="form-control"
                  disabled
                  value={modalData.branchName}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Team *</label>
                <input
                  type="text"
                  className="form-control"
                  disabled
                  value={modalData.staffName}
                />
              </div>
              <Calendars
                onChange={(e) => {
                  timesSlot(e);
                  setSlotTime([]);
                }}
              />
              <ScrollBars
                horizontal
                style={{ height: "200px", width: "100%", marginTop: "10px" }}
                smoothScrolling={true}
              >
                <div className="form-check mt-2 mb-2">
                  {slots.length ? null : (
                    <h4 className="text-center">No Slots Available</h4>
                  )}
                  {slots?.map((item, index) => (
                    <div key={index}>
                      <div className="row">
                        <button
                          disabled={
                            item.status === "Booked" ||
                            item.status === "Unavailable"
                              ? true
                              : false
                          }
                          type="button"
                          style={{
                            backgroundColor: item.isActive ? "#f47d3a" : "#fff",
                            color:
                              item.status === "Booked" ||
                              item.status === "Unavailable"
                                ? "grey"
                                : item.isActive
                                  ? "#fff"
                                  : "#f47d3a",
                            width: "300px",
                            marginLeft: "2px",
                            border:
                              item.status === "Booked" ||
                              item.status === "Unavailable"
                                ? "1px solid grey"
                                : "1px solid #f47d3a",
                          }}
                          className="btn me-5 mb-2 col-sm-12"
                          onClick={() => {
                            setSlots((prevState) => {
                              const newData = prevState.map((el, i) => {
                                if (i === index)
                                  return { ...el, isActive: true };
                                else return { ...el, isActive: false };
                              });
                              return [...newData];
                            });
                            setSlotTime(item);
                          }}
                        >
                          {moment(item.startTime).format("LT")} -{" "}
                          {moment(item.endTime).format("LT")}{" "}
                          {item.status === "Booked"
                            ? "Booked"
                            : item.status === "Unavailable"
                              ? "Unavailable"
                              : null}
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </ScrollBars>
              <div className="d-grid  col-6 mx-auto mb-4">
                <button
                  disabled={slotTime.length === 0 ? true : false}
                  className="btn colorbtun popupbtn px"
                  onClick={() => appointmentReschedule()}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </Offcanvas>
      </Backdrop>
      {/* Appointment Reschedule End */}

      {/* Filter Start */}
      <Offcanvas
        show={showFilter}
        onHide={() => setShowFilter(false)}
        placement="end"
        style={{ height: "100vh" }}
      >
        <div style={{ padding: "10px" }}>
          <button
            type="button"
            className="btn-close mb-3"
            onClick={() => setShowFilter(false)}
          ></button>
          <div className="d-flex justify-content-between">
            <h3 className="heading-color " id="offcanvasRightLabel">
              Filters
            </h3>
            <h3
              className=" heading-color"
              id="offcanvasRightLabel"
              onClick={() => clearAllFilter()}
              style={{ cursor: "pointer" }}
            >
              Clear All
            </h3>
          </div>
        </div>
        <hr style={{ margin: "0em" }} />
        <div className="">
          <div className="d-flex align-items-start sidenav">
            <div
              className="col-sm-6 col-md-5 col-lg-5 col-xl-5 sidenavlink"
              style={{ borderRight: "1px solid #EAEAEA", height: "auto" }}
            >
              <div
                className="nav flex-column nav-pills ms-2 me-2 mt-1"
                id="v-pills-tab"
                role="tablist"
                aria-orientation="vertical"
              >
                <button
                  className="nav-link active text-black"
                  id="daterange"
                  data-bs-toggle="pill"
                  data-bs-target="#datepill"
                  type="button"
                  role="tab"
                  aria-controls="datepill"
                  aria-selected="true"
                >
                  Date Range
                </button>
                {/* <button className="nav-link text-black" id="branch" data-bs-toggle="pill" data-bs-target="#branchpill" type="button" role="tab" aria-controls="branchpill" aria-selected="false">
                  Branch
                </button> */}
                <button
                  className="nav-link text-black"
                  id="team"
                  data-bs-toggle="pill"
                  data-bs-target="#teampill"
                  type="button"
                  role="tab"
                  aria-controls="teampill"
                  aria-selected="false"
                >
                  Team
                </button>
                <button
                  className="nav-link text-black"
                  id="client"
                  data-bs-toggle="pill"
                  data-bs-target="#clientpill"
                  type="button"
                  role="tab"
                  aria-controls="clientpill"
                  aria-selected="false"
                >
                  Client
                </button>
                <button
                  className="nav-link text-black"
                  id="status"
                  data-bs-toggle="pill"
                  data-bs-target="#statuspill"
                  type="button"
                  role="tab"
                  aria-controls="statuspill"
                  aria-selected="false"
                >
                  Status
                </button>
              </div>
            </div>
            <div className="col-sm-6 col-md-7 col-lg-7 col-xl-7 ps-1 pe-1 mt-1 ">
              <div className="tab-content" id="v-pills-tabContent">
                {/* Date Range Start */}
                <div
                  className="tab-pane fade show active"
                  id="datepill"
                  role="tabpanel"
                  aria-labelledby="daterange"
                  tabIndex="0"
                >
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="today"
                      name="flexRadioDefault"
                      onClick={() => {
                        setDateFilter("TODAY");
                        localStorage.removeItem("status");
                      }}
                      checked={dateFilter === "TODAY"}
                    />
                    <label className="form-check-label" htmlFor="today">
                      Today's
                    </label>
                  </div>
                  {/* <hr /> */}
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="last7"
                      name="flexRadioDefault"
                      onClick={() => {
                        setDateFilter("LAST7");
                        localStorage.removeItem("status");
                      }}
                      checked={dateFilter === "LAST7"}
                    />
                    <label className="form-check-label" htmlFor="last7">
                      Last 7 Days
                    </label>
                  </div>
                  {/* <hr /> */}
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="last30"
                      name="flexRadioDefault"
                      onClick={() => {
                        setDateFilter("LAST30");
                        localStorage.removeItem("status");
                      }}
                      checked={dateFilter === "LAST30"}
                    />
                    <label className="form-check-label" htmlFor="last30">
                      Last 30 Days
                    </label>
                  </div>
                  {/* <hr /> */}
                  <div className="form-check mb-3">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="last30"
                      name="flexRadioDefault"
                      onClick={() => {
                        setDateFilter("CUSTOM");
                        localStorage.removeItem("status");
                      }}
                      checked={dateFilter === "CUSTOM"}
                    />
                    <label className="form-check-label" htmlFor="last30">
                      Custom
                    </label>
                  </div>
                  {/* <hr /> */}
                  {dateFilter === "CUSTOM" ? (
                    <div className="d-flex flex-column align-items-center">
                      <div className="w-100">
                        <input
                          type="date"
                          className="form-control"
                          name="startDate"
                          value={filterInput.startDate}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="col-auto">-</div>
                      <div className="w-100">
                        <input
                          type="date"
                          className="form-control"
                          name="endDate"
                          value={filterInput.endDate}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                  ) : null}
                </div>
                {/* Date Range End */}

                {/* Branch Start */}
                {/* <div className="tab-pane fade" id="branchpill" role="tabpanel" aria-labelledby="branch" tabIndex="0">
                  <input type="search" className="form-control" placeholder="Search Branch......" onChange={handleChange} name="branchFil" />
                  <ScrollBars horizontal autoHide={false} smoothScrolling={true} >
                    {branchList
                      .filter((value) => value.name.toLowerCase().includes(val.branchFil.toLowerCase()))
                      .map((branchData, i) => (
                        <div className="form-check" key={branchData._id}>
                          <label className="form-check-label" htmlFor={branchData.name}>
                            <input className="form-check-input" type="checkbox" id={branchData._id}
                              checked={branchData.isChecked} onClick={() => localStorage.removeItem('status')}
                              value={branchData._id} name="branch" onChange={(e) => { setBranches(e, branchData._id, i) }} />
                            {branchData.name}
                          </label>
                        </div>
                      ))}
                  </ScrollBars>
                </div> */}
                {/* Branch End */}

                {/* Team Start */}
                <div
                  className="tab-pane fade"
                  id="teampill"
                  role="tabpanel"
                  aria-labelledby="team"
                  tabIndex="0"
                >
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Search Team......"
                    onChange={handleChange}
                    name="teamFil"
                  />
                  <ScrollBars
                    horizontal
                    autoHide={false}
                    smoothScrolling={true}
                  >
                    {teamList
                      ?.filter((value) =>
                        value.name
                          .toLowerCase()
                          .includes(val.teamFil.toLowerCase()),
                      )
                      ?.map((data, i) => (
                        <div className="form-check" key={data._id}>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id={data._id}
                            onClick={() => localStorage.removeItem("status")}
                            checked={data.isChecked}
                            value={data._id}
                            name="team"
                            onChange={(e) => setTeam(e, data._id, i)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexCheckDefault"
                          >
                            {data.name}
                          </label>
                        </div>
                      ))}
                  </ScrollBars>
                </div>
                {/* Team End */}

                {/* Client Start */}
                <div
                  className="tab-pane fade"
                  id="clientpill"
                  role="tabpanel"
                  aria-labelledby="client"
                  tabIndex="0"
                >
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Search Client......"
                    onChange={handleChange}
                    name="clientFil"
                  />
                  <ScrollBars
                    horizontal
                    autoHide={false}
                    smoothScrolling={true}
                  >
                    {clientList
                      ?.filter((value) =>
                        value.name
                          .toLowerCase()
                          .includes(val.clientFil.toLowerCase()),
                      )
                      ?.map((data, i) => (
                        <div className="form-check" key={data._id}>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="flexCheckDefault"
                            onClick={() => localStorage.removeItem("status")}
                            name="client"
                            checked={data.isChecked}
                            value={data._id}
                            onChange={(e) => setClient(e, data._id, i)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexCheckDefault"
                          >
                            {data.name}
                          </label>
                        </div>
                      ))}
                  </ScrollBars>
                </div>
                {/* Client End */}

                {/* Services Start */}
                {/* <div className="tab-pane fade" id="servicepill" role="tabpanel" aria-labelledby="service" tabIndex="0">
                  <input type="search" className="form-control" placeholder="Search Service......" onChange={handleChange} name="serviceFil" />
                  <ScrollBars horizontal autoHide={false} smoothScrolling={true} >
                    {serviceList
                      .filter((value) => value.name.toLowerCase().includes(val.serviceFil.toLowerCase()))
                      ?.map((serviceData, i) => (
                        <div className="form-check" key={serviceData._id}>
                          <input className="form-check-input" type="checkbox" id="flexCheckDefault" onClick={() => localStorage.removeItem('status')} checked={serviceData.isChecked} value={serviceData._id} name="service" onChange={(e) => setService(e, serviceData._id, i)} />
                          <label className="form-check-label" htmlFor="flexCheckDefault">
                            {serviceData.name}
                          </label>
                        </div>
                      ))}
                  </ScrollBars>
                </div> */}
                {/* Services End */}

                {/* Status Start */}
                <div
                  className="tab-pane fade"
                  id="statuspill"
                  role="tabpanel"
                  aria-labelledby="status"
                  tabIndex="0"
                >
                  {statusNames?.map((item, i) => (
                    <div className="form-check" key={i}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="flexCheckDefault"
                        onClick={() => localStorage.removeItem("status")}
                        name="status"
                        checked={item.isChecked}
                        value={item.value}
                        onChange={(e) => setStatus(e, item.value, i)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexCheckDefault"
                      >
                        {item.name}
                      </label>
                    </div>
                  ))}
                </div>
                {/* Status End */}
              </div>
            </div>
          </div>
          <div className="d-grid  col-6 mx-auto mb-2">
            <button
              className="btn colorbtun addbtn3 px"
              type="submit"
              onClick={() => {
                getAppointmentData();
              }}
            >
              Search
            </button>
          </div>
        </div>
      </Offcanvas>
      {/* Filter End */}

      {/* Appointment Delete Start */}
      <Modal
        centered
        size="sm"
        show={showDelete}
        onHide={() => setShowDelete(false)}
      >
        <div className="modal-content">
          <div className="modal-body text-center">
            <p>Are you sure !</p>
            <p>You want to delete this appointment</p>
            <button
              type="button"
              className="btn nobtn"
              data-bs-dismiss="modal"
              onClick={() => appointmentDelete()}
            >
              Yes
            </button>
            <button
              type="button"
              className="btn  ms-1 yesbtn"
              data-bs-dismiss="modal"
              onClick={() => setShowDelete(false)}
            >
              No
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        centered
        show={showUpdateStaff}
        onHide={() => setShowUpdateStaff(false)}
      >
        <div className="modal-content">
          <div className="modal-body text-center">
            <p>Are you sure !</p>

            <div className="col-md-12 cus-form mt-2">
              <label className="form-label">
                You want to assign team member for this appointment
              </label>
            </div>
            <div className="mt-3">
              <select
                className="form-select form-control"
                value={selectedStaffId}
                onChange={(e) => setSelectedStaffId(e.target.value)}
              >
                <option value="">Select team member</option>
                {teamMemberList.map((member) => (
                  <option key={member._id} value={member._id}>
                    {member.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="mt-5">
              <button
                type="button"
                className="btn nobtn"
                data-bs-dismiss="modal"
                onClick={() => updateStaff()}
                disabled={!selectedStaffId}
              >
                Yes
              </button>
              <button
                type="button"
                className="btn  ms-1 yesbtn"
                data-bs-dismiss="modal"
                onClick={() => setShowUpdateStaff(false)}
              >
                No
              </button>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        centered
        size="lg"
        show={showBillGenModal}
        onHide={() => {
          setShowBillGenModal(false);
          getBranchList();
          bookAppointmentFormik.resetForm();
        }}
      >
        <div className="modal-content">
          <div className="modal-body text-center">
            <h6 className="text-center">Bill Generate</h6>
            <form
              onSubmit={bookAppointmentFormik.handleSubmit}
              className="row ps-4 cus-form mt-4"
            >
              <div class=" py-3 mb-3 rounded row">
                <div className="col-md-6 mt-2">
                  <div className="mb-1 d-flex flex-column align-items-start">
                    <label className="form-label">Client</label>
                    <select
                      onChange={bookAppointmentFormik.handleChange}
                      onBlur={bookAppointmentFormik.handleBlur}
                      value={bookAppointmentFormik.values.clientId}
                      className="form-control form-control"
                      name="clientId"
                    >
                      <option value="">Select client</option>
                      {clientData.map((item) => (
                        <option value={item._id} key={item._id}>
                          {item?.name}
                        </option>
                      ))}
                    </select>
                    {bookAppointmentFormik.touched.clientId &&
                      bookAppointmentFormik.errors.clientId && (
                        <div className="text-danger small">
                          {bookAppointmentFormik.errors.clientId}
                        </div>
                      )}
                  </div>
                </div>
                <div className="col-md-6 mt-2">
                  <div className="mb-1 d-flex flex-column align-items-start">
                    <label className="form-label">Branch</label>
                    <select
                      onChange={bookAppointmentFormik.handleChange}
                      onBlur={bookAppointmentFormik.handleBlur}
                      value={bookAppointmentFormik.values.branchId}
                      disabled
                      className="form-control form-control"
                      name="branchId"
                    >
                      {branchData.map((item) => (
                        <option value={item._id} key={item._id}>
                          {item?.name}
                        </option>
                      ))}
                    </select>
                    {bookAppointmentFormik.touched.branchId &&
                      bookAppointmentFormik.errors.branchId && (
                        <div className="text-danger small">
                          {bookAppointmentFormik.errors.branchId}
                        </div>
                      )}
                  </div>
                </div>
                <div className="col-md-6 mt-2">
                  <div className="mb-1 d-flex flex-column align-items-start">
                    <label className="form-label">Team</label>
                    <select
                      onChange={bookAppointmentFormik.handleChange}
                      onBlur={bookAppointmentFormik.handleBlur}
                      value={bookAppointmentFormik.values.staffId}
                      className="form-control form-control"
                      name="staffId"
                    >
                      <option value="">Select team</option>
                      {teamMember.map((item) => (
                        <option value={item._id} key={item._id}>
                          {item?.name}
                        </option>
                      ))}
                    </select>
                    {bookAppointmentFormik.touched.staffId &&
                      bookAppointmentFormik.errors.staffId && (
                        <div className="text-danger small">
                          {bookAppointmentFormik.errors.staffId}
                        </div>
                      )}
                  </div>
                </div>
                <div className="col-md-6 mt-2">
                  <div className="mb-1 d-flex flex-column align-items-start">
                    <label className="form-label">Service Category</label>
                    <select
                      onChange={(e) => {
                        const value = e.target.value;
                        setCategoryId(value);
                        bookAppointmentFormik.setFieldValue(
                          "categoryId",
                          value,
                        );
                      }}
                      onBlur={bookAppointmentFormik.handleBlur}
                      value={bookAppointmentFormik.values.categoryId}
                      className="form-control form-control"
                      name="categoryId"
                    >
                      <option value="">Select service category</option>
                      {serviceCategoryList.map((item) => (
                        <option value={item._id} key={item._id}>
                          {item?.name}
                        </option>
                      ))}
                    </select>
                    {bookAppointmentFormik.touched.categoryId &&
                      bookAppointmentFormik.errors.categoryId && (
                        <div className="text-danger small">
                          {bookAppointmentFormik.errors.categoryId}
                        </div>
                      )}
                  </div>
                </div>

                <div className="col-md-6 mt-2">
                  <div className="mb-1 d-flex flex-column align-items-start">
                    <label className="form-label">Service</label>
                    <select
                      onChange={(e) =>
                        handleServiceChange(
                          e,
                          serviceList,
                          bookAppointmentFormik,
                        )
                      }
                      onBlur={bookAppointmentFormik.handleBlur}
                      value={bookAppointmentFormik.values.serviceId}
                      className="form-control form-control"
                      name="serviceId"
                      disabled={!bookAppointmentFormik.values.categoryId}
                    >
                      <option value="">Select service</option>
                      {serviceList.map((item) => (
                        <option value={item._id} key={item._id}>
                          {item?.name}
                        </option>
                      ))}
                    </select>
                    {bookAppointmentFormik.touched.serviceId &&
                      bookAppointmentFormik.errors.serviceId && (
                        <div className="text-danger small">
                          {bookAppointmentFormik.errors.serviceId}
                        </div>
                      )}
                  </div>
                </div>

                <div className="col-md-6 mt-2">
                  <div className="mb-1 d-flex flex-column align-items-start">
                    <label className="form-label">Amount</label>
                    <input
                      onChange={bookAppointmentFormik.handleChange}
                      onBlur={bookAppointmentFormik.handleBlur}
                      value={bookAppointmentFormik.values.amount}
                      name="amount"
                      type="text"
                      className="form-control alreadytext"
                    />
                    {bookAppointmentFormik.touched.amount &&
                      bookAppointmentFormik.errors.amount && (
                        <div className="text-danger small">
                          {bookAppointmentFormik.errors.amount}
                        </div>
                      )}
                  </div>
                </div>
                <div className="col-md-6 mt-2">
                  <div className="mb-1 d-flex flex-column align-items-start">
                    <label className="form-label">Start Date & Time</label>
                    <input
                      onChange={bookAppointmentFormik.handleChange}
                      onBlur={bookAppointmentFormik.handleBlur}
                      value={bookAppointmentFormik.values.startDateTime}
                      name="startDateTime"
                      type="datetime-local"
                      className="form-control alreadytext"
                    />
                    {bookAppointmentFormik.touched.startDateTime &&
                      bookAppointmentFormik.errors.startDateTime && (
                        <div className="text-danger small">
                          {bookAppointmentFormik.errors.startDateTime}
                        </div>
                      )}
                  </div>
                </div>

                <div className="col-md-6 mt-2">
                  <div className="mb-1 d-flex flex-column align-items-start">
                    <label className="form-label">End Date & Time</label>
                    <input
                      onChange={bookAppointmentFormik.handleChange}
                      onBlur={bookAppointmentFormik.handleBlur}
                      value={bookAppointmentFormik.values.endDateTime}
                      name="endDateTime"
                      type="datetime-local"
                      className="form-control alreadytext"
                    />
                    {bookAppointmentFormik.touched.endDateTime &&
                      bookAppointmentFormik.errors.endDateTime && (
                        <div className="text-danger small">
                          {bookAppointmentFormik.errors.endDateTime}
                        </div>
                      )}
                  </div>
                </div>

                <div className="col-md-6 mt-2">
                  <div className="mb-1 d-flex flex-column align-items-start">
                    <label className="form-label">Visit Type</label>
                    <select
                      onChange={bookAppointmentFormik.handleChange}
                      onBlur={bookAppointmentFormik.handleBlur}
                      value={bookAppointmentFormik.values.visitType}
                      className="form-control form-control"
                      name="visitType"
                    >
                      <option value="">Select visit type</option>
                      {visitType.map((item) => (
                        <option value={item.id} key={item.id}>
                          {item?.name}
                        </option>
                      ))}
                    </select>
                    {bookAppointmentFormik.touched.visitType &&
                      bookAppointmentFormik.errors.visitType && (
                        <div className="text-danger small">
                          {bookAppointmentFormik.errors.visitType}
                        </div>
                      )}
                  </div>
                </div>
              </div>

              <div className="d-flex gap-2 align-items-center">
                <div className="d-flex gap-2">
                  <label className="form-check-label" htmlFor="emailCheckbox">
                    Send Email
                  </label>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="emailCheckbox"
                      checked={bookAppointmentFormik.values.isSendMail}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        bookAppointmentFormik.setFieldValue(
                          "isSendMail",
                          isChecked,
                        );
                        // Clear email field when unchecked
                        if (!isChecked) {
                          bookAppointmentFormik.setFieldValue("email", "");
                        }
                      }}
                    />
                  </div>
                </div>

                {bookAppointmentFormik.values.isSendMail && (
                  <div className="w-75">
                    <div className="mb-1 d-flex flex-column align-items-start w-50">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter email"
                        name="email"
                        onChange={bookAppointmentFormik.handleChange}
                        onBlur={bookAppointmentFormik.handleBlur}
                        value={bookAppointmentFormik.values.email || ""}
                      />
                      {bookAppointmentFormik.touched.email &&
                        bookAppointmentFormik.errors.email && (
                          <div className="text-danger small">
                            {bookAppointmentFormik.errors.email}
                          </div>
                        )}
                    </div>
                  </div>
                )}
              </div>

              <div
                className="d-flex justify-content-end"
                style={{ paddingRight: "50px" }}
              >
                <button
                  type="submit"
                  className="btn yesbtn w-25"
                  disabled={bookAppointmentFormik.isSubmitting}
                >
                  {bookAppointmentFormik.isSubmitting
                    ? "Submitting..."
                    : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
      {/* Appointment Delete End */}
    </>
  );
};

export default AppointmentList;
